<template>
    <div class="Container">       
        <div class="Box ClassicIkarusHolder">
            <div class="ClassicIkarus owl-carousel owl-theme">
                <Catalog 
                v-for="catalog in this.listCatalogs" :key="catalog.IdCatalogo"
                :urlImmagine="catalog.UrlImmagine" 
                :idCatalogo="catalog.IdCatalogo"
                :descrizione="catalog.Descrizione"
                :descrizioneDettagliata="catalog.DescrizioneDettagliata">               
                </Catalog>
            </div>
        </div>
    </div>
</template>

<script>

import Catalog from "@/components/Catalog.vue";
import CatalogsService from '@/services/catalogs.service.js'

export default{
    name: "CatalogList",
    components: {
        Catalog,
        
    },
    data(){
        return {
            listCatalogs: []
        }
    },
    created(){

        CatalogsService.getCatalogs(this.$store.getters.getToken, this.$store.getters.getLingua  ).then(

            (data) => {                      
                this.listCatalogs = data;
                $(document).ready(function() {
        
                $(".ClassicIkarus").owlCarousel({
                    margin:0,
                    autoplay:false,
                    nav:true,
                    responsive:{
                        0:{
                            items:1,
                            autoplay:true,
                            loop: ( $('.ClassicIkarus.owl-carousel > *').length > 0 )
                        },
                        600:{
                            items:2,
                            loop: ( $('.ClassicIkarus.owl-carousel > *').length > 1 )
                        },
                        1000:{
                            items:3,
                            loop: ( $('.ClassicIkarus.owl-carousel > *').length > 2 )
                        },
                        1300:{
                            items:3,
                            loop: ( $('.ClassicIkarus.owl-carousel > *').length > 2 )
                        },
                        1600:{
                            items:3,
                            loop: ( $('.ClassicIkarus.owl-carousel > *').length > 2 )
                        }
                    }
                });
                })                                   
            }          
        ).catch(
            error => {return false}
        );




    }
}
</script>
